import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { SEO } from "../components/SEO";

export default function NotFoundPage() {
    return (
        <>
            <SEO
                title="Page not found — 033 Digital"
                description="The page you're looking for doesn't exist."
                path="/404"
            />
            <Navbar />
            <main className="girder-grid flex min-h-[70vh] items-center px-4 pb-24 pt-32 sm:px-8" data-testid="not-found-page">
                <div className="mx-auto max-w-2xl text-center">
                    <p className="font-mono text-xs font-semibold uppercase tracking-[0.3em] text-brand-orange">Error 404</p>
                    <h1 className="mt-4 font-display text-4xl font-bold tracking-tight text-brand-brown sm:text-5xl">
                        This page slipped through a leak.
                    </h1>
                    <p className="mt-5 text-sm leading-relaxed text-brand-muted sm:text-base">
                        The page you're looking for doesn't exist — but your customers' journey back is one tap away.
                    </p>
                    <Link
                        to="/"
                        data-testid="not-found-home-link"
                        className="mt-9 inline-flex items-center gap-2 rounded-full bg-brand-orange px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-brand-orange-dark"
                    >
                        <ArrowLeft size={16} aria-hidden="true" />
                        Back to home
                    </Link>
                </div>
            </main>
            <Footer />
        </>
    );
}
